// Approval cards: an extension waits for the USER's click before it places,
// changes or cancels an order. Same component on desktop and web (relay).
import { useEffect, useState } from "react";
import { useDataClient, type ApprovalRequest } from "./client";

export function ApprovalCards({ thread, everyMs = 1500 }: { thread?: string | null; everyMs?: number }) {
  const api = useDataClient().approvals;
  const [list, setList] = useState<ApprovalRequest[]>([]);
  const [busy, setBusy] = useState<string | null>(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!api) return;
    let live = true;
    const load = () => api.pending().then((l) => live && setList(l)).catch(() => {});
    load();
    const t = setInterval(load, everyMs);
    return () => { live = false; clearInterval(t); };
  }, [api, everyMs]);
  if (!api || list.length === 0) return null;
  // This chat's requests first; others still show (an order can't wait unseen).
  const shown = [...list].sort((a, b) => Number(b.thread === thread) - Number(a.thread === thread));
  const answer = async (id: string, approved: boolean) => {
    setBusy(id); setErr("");
    try { await api.resolve(id, approved); setList((l) => l.filter((x) => x.id !== id)); }
    catch (e) { setErr(String(e)); }
    finally { setBusy(null); }
  };
  return (
    <div className="ab-approvals">
      {shown.map((r) => (
        <div key={r.id} className="ab-approval" role="alertdialog" aria-label={r.title}>
          <div className="ab-approval-title">{r.title}{r.thread && thread && r.thread !== thread ? <span> · another chat</span> : null}</div>
          <ul>{r.lines.map((l, i) => <li key={i}>{l}</li>)}</ul>
          <div className="ab-approval-actions">
            <button className="decline" disabled={busy === r.id} onClick={() => void answer(r.id, false)}>Decline</button>
            <button className="approve" disabled={busy === r.id} onClick={() => void answer(r.id, true)}>Approve</button>
          </div>
        </div>
      ))}
      {err && <div className="ab-approval-err">{err}</div>}
    </div>
  );
}
